import React                from 'react';
import { WithStyle, withStyles } from 'rewire-ui';
import { Theme}                  from '@material-ui/core/styles';
import TimecardGrid, {
  TimecardGridHeader,
  timecardGridHeaderClassKey,
  ITimecardGridHeaderProps,
  ITimecardGridProps,
}                                from './TimecardGrid';

const headerStyles = (_theme: Theme) => ({
  // ...timecardGridHeaderStyles(theme),
});

interface ITimecardTemplateGridHeaderProps extends ITimecardGridHeaderProps {
}

type TimecardTemplateGridHeaderProps = WithStyle<ReturnType<typeof headerStyles> & timecardGridHeaderClassKey, ITimecardTemplateGridHeaderProps>;

export const TimecardTemplateGridHeader = withStyles<Omit<TimecardTemplateGridHeaderProps, 'classes'>,unknown>(headerStyles, class extends React.PureComponent<TimecardTemplateGridHeaderProps> {
  constructor(props: TimecardTemplateGridHeaderProps) {
    super(props);
  }

  render() {
    return <TimecardGridHeader {...this.props} />;
  }
});

const styles = (_theme: Theme) => ({
    // ...timecardGridStyles(theme),
});

interface ITimecardTemplateGridProps extends ITimecardGridProps {
}

type TimecardTemplateGridProps = WithStyle<ReturnType<typeof styles>, ITimecardTemplateGridProps>;

class TimecardTemplateGrid extends React.PureComponent<TimecardTemplateGridProps> {
  constructor(props: TimecardTemplateGridProps) {
    super(props);
  }

  render() {
    return <TimecardGrid {...this.props} />;
  }
}

export default withStyles(styles, TimecardTemplateGrid);
